import ReactPropTypes from 'prop-types';
import React from 'react';

import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';

export default function DeliveryInformationETicket({
    email,
    isGuest = false,
    isPaypal = false,
    isAmazonPay = false
}) {
    return (
        <div>
            <p>
                <FormattedHTMLMessage message='order.details.eTicketDelivery'
                                      email={email}
                                      isGuest={isGuest}
                                      isPaypal={isPaypal}
                                      isAmazonPay={isAmazonPay}/>
            </p>
        </div>
    );
}

DeliveryInformationETicket.propTypes = {
    email: ReactPropTypes.string.isRequired,
    isGuest: ReactPropTypes.bool,
    isPaypal: ReactPropTypes.bool,
    isAmazonPay: ReactPropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/checkout/orderSummary/DeliveryInformationETicket.js